import React from 'react';
import cn from 'classnames';
import { CartItemType } from '@base/cart/interface';
import { hasWholeSalePrice } from '@pro/product/utils';
import { useTrans } from 'base/utils/i18n';

type CartItemBonusTipProps = {
    className: string;
    item: CartItemType;
};

const CartItemWholesaleTip: React.FC<CartItemBonusTipProps> = props => {
    const { className, item } = props;
    const { t } = useTrans();

    return hasWholeSalePrice(item) && item.num < item.wholesaleMinSaleQuantity ? (
        <div className={cn(className, 'item-fail-tip')}>
            {t('web_wholesale_cart_item_fail', { qty: item.wholesaleMinSaleQuantity - item.num })}
        </div>
    ) : null
};

export default CartItemWholesaleTip;